import { KeyboardEvent, Ref } from 'react';
import { InputAdornment, TextField } from '@mui/material';

export const CX_SPEND_LABEL = 'Current Monthly CX Spend';

export interface SpendAmountInputProps {
  text: string;
  error: string | null;
  disabled?: boolean;
  inputRef?: Ref<HTMLInputElement>;
  onChange: (text: string) => void;
  onBlur: () => void;
  onKeyDown?: (event: KeyboardEvent) => void;
}

export const SpendAmountInput = ({
  text,
  error,
  disabled,
  inputRef,
  onChange,
  onBlur,
  onKeyDown
}: SpendAmountInputProps) => (
  <TextField
    size="small"
    fullWidth
    value={text}
    disabled={disabled}
    inputRef={inputRef}
    placeholder="Enter monthly spend"
    error={!!error}
    helperText={error}
    inputProps={{ inputMode: 'decimal', 'aria-label': CX_SPEND_LABEL, style: { textAlign: 'right' } }}
    InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
    onChange={(event) => onChange(event.target.value)}
    onBlur={onBlur}
    onKeyDown={onKeyDown}
  />
);
